module.exports = __webpack_public_path__ + "img/sf.5bf17ab8.png";